import React from "react";

import { Text } from "@performyard/py-components";

type SettingsSectionProps = {
	title: string;
	description: string;
	children: React.ReactNode;
};

const SettingsSection = ({ title, description, children }: SettingsSectionProps) => {
	return (
		<div className="mb-10 grid w-full grid-cols-[368px_1fr_546px] gap-6">
			<div className="space-y-2">
				<Text size="paragraph-2" weight="semi-bold" color="neutral-9">
					{title}
				</Text>
				<Text size="paragraph-3" weight="regular" color="neutral-9">
					{description}
				</Text>
			</div>
			<div />
			<div>{children}</div>
		</div>
	);
};

export default SettingsSection;
